import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PromptService, Prompt } from '@services/prompt.service';

@Component({
    selector: 'app-prompt-edit',
    templateUrl: './prompt-edit.component.html',
    styleUrls: ['./prompt-edit.component.css']
})
export class PromptEditComponent implements OnInit {
    @Input() isEditMode = false;
    @Input() promptData!: Prompt;

    promptForm: FormGroup;
    submitted = false;

    constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private promptService: PromptService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.promptForm = this.fb.group({
            name: ['', Validators.required],
            systemPrompt: ['', Validators.required],
            userPrompt: ['', Validators.required]
        });

        if (this.isEditMode && this.promptData) {
            this.promptForm.patchValue({
                name: this.promptData.name,
                systemPrompt: this.promptData.systemPrompt,
                userPrompt: this.promptData.userPrompt
            });
        }
    }

    save(): void {
        this.submitted = true;

        if (!this.promptForm.valid) {
            this.promptForm.markAllAsTouched();
            this.toastr.warning('Lütfen gerekli alanları doldurunuz', 'Uyarı');
            return;
        }

        const prompt: Prompt = this.promptForm.value;

        if (this.isEditMode) {
            prompt.id = this.promptData.id;
            this.promptService.update(this.promptData.id!, prompt).subscribe({
                next: () => {
                    this.toastr.success('Prompt başarıyla güncellendi', 'Başarılı');
                    this.activeModal.close(true);
                },
                error: () => {
                    this.toastr.error('Prompt güncellenirken hata oluştu', 'Hata');
                    this.submitted = false;
                }
            });
        } else {
            this.promptService.create(prompt).subscribe({
                next: () => {
                    this.toastr.success('Prompt başarıyla oluşturuldu', 'Başarılı');
                    this.activeModal.close(true);
                },
                error: () => {
                    this.toastr.error('Prompt oluşturulurken hata oluştu', 'Hata');
                    this.submitted = false;
                }
            });
        }
    }

    close(): void {
        this.activeModal.dismiss();
    }
}
